<div [formGroup]="beneficiary">
  <ng-container>
    <p
      *ngIf="isBneficiarioValido == 'invalid' && coincidenciaEncontrada"
      class="text-center msn-error--inline is-inactive color-red"
    >
      El beneficiario con identificación
      {{ numeroDocumentoBeneficiario }} tiene una solicitud en proceso
    </p>
    <p
      *ngIf="isBneficiarioValido == 'invalid-group'"
      class="text-center msn-error--inline is-inactive color-red"
    >
      El tipo de documento y número de documento ya existe dentro de tu grupo
      familiar
    </p>
  </ng-container>
  <h2 class="font-20 u-medium t-align-initial color-blue-dark f-16">
    Información beneficiario
  </h2>
  <div class="row mg-top-20">
    <!-- Parentesco -->
    <div class="col-md-3 col-sm-6 col-xs-12">
      <div class="c-field mg-btm-30">
        <label
          aria-label="Seleccione parentesco"
          for="parentescoPerCarg_{{ index }}"
          class="u-medium t-align-initial f-14 r-show color-blue-dark"
        >Tipo de parentesco
        </label>
        <div class="select-custom-mat">
          <select formControlName="parentescoPerCarg" id="parentescoPerCarg_{{ index }}" aria-required="true"
                  [ngClass]="{
              hasError:
                beneficiary?.get('parentescoPerCarg')?.errors &&
                beneficiary?.get('parentescoPerCarg')?.touched
            }">
            <option value="" disabled selected></option>
            <option
              *ngFor="
                let parentesco of beneficiary.get('parentescosValidos').value
              "
              [ngValue]="parentesco"
            >
              {{ parentesco.name }}
            </option>
          </select>
        </div>
        <app-form-errors *ngIf="beneficiary?.get('parentescoPerCarg')?.touched"
                         [errors]="beneficiary?.get('parentescoPerCarg')?.errors">
          Campo obligatorio
        </app-form-errors>
      </div>
    </div>
    <!-- Tipo documento -->
    <div class="col-md-3 col-sm-6 col-xs-12">
      <div class="c-field mg-btm-30">
        <label aria-label="Seleccione tipo de documento de identidad" for="tipoDocumento_{{ index }}"
               class="u-medium t-align-initial f-14 r-show color-blue-dark">Tipo de documento</label
        >
        <div class="select-custom-mat">
          <select
            formControlName="tipoDocumentoObjeto"
            id="tipoDocumentoObjeto_{{ index }}"
            aria-required="true"
            [ngClass]="{
              hasError:
                beneficiary?.get('tipoDocumentoObjeto')?.errors &&
                beneficiary?.get('tipoDocumentoObjeto')?.touched
            }"
          >
            <option value="" selected></option>
            <option
              *ngFor="let tipoIdentificacion of tiposIdentificacion"
              [ngValue]="tipoIdentificacion"
            >
              {{ tipoIdentificacion.nombre }}
            </option>
          </select>
        </div>
        <app-form-errors
          *ngIf="beneficiary?.get('tipoDocumentoObjeto')?.touched"
          [errors]="beneficiary?.get('tipoDocumentoObjeto')?.errors"
        >
          Campo obligatorio
        </app-form-errors>
      </div>
    </div>
    <!-- Numero documento -->
    <div class="col-md-3 col-sm-6 col-xs-12">
      <div class="c-field mg-btm-30">
        <label
          aria-label="Escriba número de documento de identidad"
          for="numeroDocumento_{{ index }}"
          class="u-medium t-align-initial f-14 r-show color-blue-dark"
        >Número de documento</label
        >
        <div class="c-field_cont c-field_cont--right">
          <input
            type="text"
            formControlName="numeroDocumento"
            id="numeroDocumento_{{ index }}"
            aria-required="true"
            (blur)="obtenerSolicitudesDeAcreditadorEnProcesoDeAfiliado(beneficiary?.get('tipoDocumentoObjeto').value.valor,$event.target.value); showCalendarFromBlurDocument($event);"
          />
          <em aria-hidden="true" class="material-icons material-icons-input"
          >subtitles</em
          >
        </div>
        <app-form-errors
          *ngIf="beneficiary?.get('numeroDocumento')?.touched"
          [errors]="beneficiary?.get('numeroDocumento')?.errors"
        >
          Campo obligatorio
        </app-form-errors>
      </div>
    </div>
    <!-- Genero -->
    <div class="col-md-3 col-sm-6 col-xs-12">
      <div class="c-field mg-btm-30">
        <label
          aria-label="Seleccione género"
          for="genero_{{ index }}"
          class="u-medium t-align-initial f-14 r-show color-blue-dark"
        >Género</label
        >
        <div class="select-custom-mat">
          <select
            formControlName="genero"
            id="genero_{{ index }}"
            aria-required="true"
          >
            <option value="" disabled selected></option>
            <option *ngFor="let genderP of genders" [value]="genderP.value">
              {{ genderP.name }}
            </option>
          </select>
        </div>
        <app-form-errors
          *ngIf="beneficiary?.get('genero')?.touched"
          [errors]="beneficiary?.get('genero')?.errors"
        >
          Campo obligatorio
        </app-form-errors>
      </div>
    </div>
    <!-- Primer apellido -->
    <div class="col-md-3 col-sm-6 col-xs-12">
      <div class="c-field mg-btm-30">
        <label
          aria-label="Escriba primer apellido"
          for="apellido_{{ index }}"
          class="u-medium t-align-initial f-14 r-show color-blue-dark"
        >Primer apellido</label
        >
        <div class="c-field_cont c-field_cont--right">
          <input
            type="text"
            (input)="convertirAMayusculas(beneficiary?.get('apellido'))"
            class="u-uppercase"
            formControlName="apellido"
            id="apellido_{{ index }}"
            aria-required="true"
          />
          <em aria-hidden="true" class="material-icons material-icons-input"
          >account_circle</em
          >
        </div>
        <app-form-errors
          *ngIf="beneficiary?.get('apellido')?.touched"
          [errors]="beneficiary?.get('apellido')?.errors"
        >
          Campo obligatorio
        </app-form-errors>
      </div>
    </div>
    <!-- Segundo apellido -->
    <div class="col-md-3 col-sm-6 col-xs-12">
      <div class="c-field mg-btm-30">
        <label
          aria-label="Escriba segundo apellido"
          for="segundoApellido_{{ index }}"
          class="u-medium t-align-initial f-14 r-show color-blue-dark"
        >Segundo apellido</label
        ><em class="label-italic color-blue-dark"> (Opcional)</em>
        <div class="c-field_cont c-field_cont--right">
          <input
            type="text"
            (input)="convertirAMayusculas(beneficiary?.get('segundoApellido'))"
            class="u-uppercase"
            formControlName="segundoApellido"
            id="segundoApellido_{{ index }}"
          />
          <em aria-hidden="true" class="material-icons material-icons-input"
          >account_circle</em
          >
        </div>
        <app-form-errors
          *ngIf="beneficiary?.get('segundoApellido')?.touched"
          [errors]="beneficiary?.get('segundoApellido')?.errors"
        >
        </app-form-errors>
      </div>
    </div>
    <!-- Primer nombre -->
    <div class="col-md-3 col-sm-6 col-xs-12">
      <div class="c-field mg-btm-30">
        <label
          aria-label="Escriba primer nombre"
          for="primerNombre_{{ index }}"
          class="u-medium t-align-initial f-14 r-show color-blue-dark"
        >Primer nombre</label
        >
        <div class="c-field_cont c-field_cont--right">
          <input
            type="text"
            (input)="convertirAMayusculas(beneficiary?.get('primerNombre'))"
            class="u-uppercase"
            formControlName="primerNombre"
            id="primerNombre_{{ index }}"
            aria-required="true"
          />
          <em aria-hidden="true" class="material-icons material-icons-input"
          >account_circle</em
          >
        </div>
        <app-form-errors
          *ngIf="beneficiary?.get('primerNombre')?.touched"
          [errors]="beneficiary?.get('primerNombre')?.errors"
        >
          Campo obligatorio
        </app-form-errors>
      </div>
    </div>
    <!-- Segundo nombre -->
    <div class="col-md-3 col-sm-6 col-xs-12">
      <div class="c-field mg-btm-30">
        <label
          aria-label="Escriba segundo nombre"
          for="segundoNombre_{{ index }}"
          class="u-medium t-align-initial f-14 r-show color-blue-dark"
        >Segundo nombre</label
        ><em class="label-italic color-blue-dark"> (Opcional)</em>
        <div class="c-field_cont c-field_cont--right">
          <input
            type="text"
            (input)="convertirAMayusculas(beneficiary?.get('segundoNombre'))"
            class="u-uppercase"
            formControlName="segundoNombre"
            id="segundoNombre_{{ index }}"
          />
          <em aria-hidden="true" class="material-icons material-icons-input"
          >account_circle</em
          >
        </div>
        <app-form-errors
          *ngIf="beneficiary?.get('segundoNombre')?.touched"
          [errors]="beneficiary?.get('segundoNombre')?.errors"
        >
        </app-form-errors>
      </div>
    </div>
    <!-- Fecha nacimiento -->
    <div class="col-md-3 col-sm-6 col-xs-12">
      <div class="c-field mg-btm-30">
        <label
          aria-label="Escriba fecha de nacimiento"
          for="fechaNacimiento_{{ index }}"
          class="u-medium t-align-initial f-14 r-show color-blue-dark"
        >Fecha de nacimiento</label
        >
        <div class="c-field_cont c-field_cont--right">
          <input
            [min]="minimaFecha | date : 'yyyy-MM-dd'"
            [max]="maximaFecha | date : 'yyyy-MM-dd'"
            formControlName="fechaNacimiento"
            type="date"
            id="fechaNacimiento_{{ index }}"
            (focus)="showCalendar($event)"
          />
        </div>
        <app-form-errors
          *ngIf="beneficiary.get('fechaNacimiento').touched"
          [errors]="beneficiary.get('fechaNacimiento').errors"
        >
          Campo obligatorio
        </app-form-errors>
      </div>
    </div>
    <!-- Categoria -->
    <div
      class="col-md-3 col-sm-6 col-xs-12"
      *ngIf="beneficiary?.get('rangoC')?.value == true"
    >
      <div class="c-field mg-btm-30">
        <label
          for="cat_{{ index }}"
          class="color-blue-light u-medium t-align-initial f-14 r-show color-blue-dark"
          aria-hidden="true"
        >
          <a [href]="urlCategoria" target="_blank">Categoria </a>
        </label>

        <div class="c-field_cont c-field_cont--right">
          <input id="cat_{{ index }}" type="text" disabled value="C"
                 class="add-beneficiary-form-col-1-card--five-1-card-1-row-1-col-8-c-field-1-c-field_cont-1-Nombre2PerCarg-{{
              i
            }}" aria-label="Categoria del beneficiario"/>
        </div>
      </div>
      <!-- /select-custom-mat -->
    </div>
  </div>
  <ng-container *ngIf="showAddress">
    <h2 class="font-20 u-medium t-align-initial color-blue-dark f-16">
      Datos de contacto
    </h2>
    <div class="row mg-top-20">
      <!-- Direccion -->
      <div class="col-md-6 col-sm-6 col-xs-12">
        <div class="c-field mg-btm-30">
          <label aria-label="Escriba la dirección de residencia" for="direccionResidencia"
                 class="u-medium t-align-initial f-14 r-show color-blue-dark">Dirección</label
          >
          <div class="c-field_cont c-field_cont--right">
            <input
              type="text"
              class="u-uppercase"
              formControlName="direccionResidencia"
              id="direccionResidencia"
              aria-required="true"
              [ngClass]="{
                hasError:
                  beneficiary?.get('direccionResidencia')?.errors &&
                  beneficiary?.get('direccionResidencia')?.touched
              }"
              (blur)="validarDireccion($event.target.value)"
              placeholder="Ej: CL 38A BIS SUR 3A 18 ESTE "
            />
            <em aria-hidden="true" class="material-icons material-icons-input"
            >room</em
            >
          </div>
          <app-form-errors
            *ngIf="beneficiary?.get('direccionResidencia')?.touched"
            [errors]="beneficiary?.get('direccionResidencia')?.errors"
          >
            Campo obligatorio
          </app-form-errors>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="MensajeDir">
    <div class=" d-inline-block font-14 color-gray-info aviso" style="width: 48%;">
      <div class="d-flex d-flex--nowrap mg-10">
        <em class="material-icons color-blue-dark font-20"> info </em>
        <p class="mg-lft-10">
          {{ MensajeDir }}
        </p>
      </div>
    </div>
  </ng-container>


  <ng-content></ng-content>
</div>
